function filterUrl(url = "", paramsToDelete: string[] = []): string {
  if (!url || typeof url !== "string") return "";

  const [path, queryString] = url.split("?");
  if (!queryString) return url;

  const params = new URLSearchParams(queryString);
  paramsToDelete.forEach((param) => params.delete(param));

  return params.toString() ? `${path}?${params.toString()}` : path;
}

export default filterUrl;
